/**
 * Master User Permissions Configuration
 * This file defines all available master user permissions in the system.
 * 
 * These permissions are checked both on frontend (for UI visibility)
 * and backend (for API access control).
 */

export const MASTER_PERMISSIONS = {
    // AppPlus - Back Office System
    APP_PLUS_ACCESS: 'appPlus_access',
    APP_PLUS_DASHBOARD: 'appPlus_dashboard',
    APP_PLUS_CUSTOMERS: 'appPlus_customers',
    APP_PLUS_EVENTS: 'appPlus_events',
} as const;

// Type for TypeScript autocomplete and type safety
export type MasterPermission = typeof MASTER_PERMISSIONS[keyof typeof MASTER_PERMISSIONS];
